"use client";

import type { PropsWithChildren } from "react";
import { PulseProvider } from "./pulse/pulse-provider";
import { IntercomProvider } from "./intercom/IntercomProvider";
import { ProductFeedbackProvider } from "@/components/product-feedback/product-feedback-provider";
import { useCurrentUser } from "@/hooks/use-current-user";
import dynamic from "next/dynamic";
const ImpersonatorBadge = dynamic(() =>
  import("@/components/common/impersonator-badge").then(
    (module) => module.ImpersonatorBadge,
  ),
);
const DevToolsPanel = dynamic(() =>
  import("@/components/dev/dev-tools-panel").then(
    (module) => module.DevToolsPanel,
  ),
);

export function FullAppExperience({ children }: PropsWithChildren) {
  const { user } = useCurrentUser();
  return (
    <PulseProvider>
      <IntercomProvider>
        <ProductFeedbackProvider>
          {children}
          {user?.isImpersonating ? <ImpersonatorBadge /> : null}
          {process.env.NODE_ENV === "development" ? <DevToolsPanel /> : null}
        </ProductFeedbackProvider>
      </IntercomProvider>
    </PulseProvider>
  );
}
